import axios from 'axios'

const http = axios.create({
  // Development requests use vue.config.js proxy; production requests are same-origin.
  baseURL: process.env.VUE_APP_API_BASE || '',
  // Singapore deployment uses local MySQL; allow a little headroom during
  // the first database connection without making the UI fail prematurely.
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' }
})

http.interceptors.request.use(config => {
  const token = localStorage.getItem('phoenix_admin_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

export const login = payload => http.post('/api/auth/login', payload)
export const logout = () => http.post('/api/auth/logout')
export const checkSession = () => http.get('/api/auth/session')
export const listShipments = params => http.get('/api/admin/shipments', { params })
export const getShipment = trackingNo => http.get(`/api/admin/shipments/${trackingNo}`)
export const updateShipment = (trackingNo, payload) => http.put(`/api/admin/shipments/${trackingNo}`, payload)
export const getPublicShipment = trackingNo => http.get(`/api/tracking/${trackingNo}`)
export const getStatusOptions = (mode, nodeCode) => http.get('/api/admin/shipments/status-options', { params: { mode, nodeCode } })
export const saveNode = (trackingNo, nodeCode, payload) => http.put(`/api/admin/shipments/${trackingNo}/nodes/${nodeCode}`, payload)
export const createShipment = payload => http.post('/api/admin/shipments', payload)
export const deleteShipment = trackingNo => http.delete(`/api/admin/shipments/${trackingNo}`)
export const deleteShipmentById = shipmentId => http.delete(`/api/admin/shipments/by-id/${shipmentId}`)
export const listLogs = params => http.get('/api/admin/logs', { params })
export const deleteLogsByDate = date => http.delete('/api/admin/logs', { params: { date } })
export const listAdminUsers = () => http.get('/api/admin/users')
export const createAdminUser = payload => http.post('/api/admin/users', payload)
export const disableAdminUser = userId => http.delete(`/api/admin/users/${userId}`)
export const acquireShipmentLock = trackingNo => http.post(`/api/admin/shipments/${trackingNo}/lock`)
export const releaseShipmentLock = trackingNo => http.delete(`/api/admin/shipments/${trackingNo}/lock`)

export default http
